import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import Separator from "@components/CustomTypography/Separator/Separator"
import ManagementTeamSection from "@components/Pages/Management/ManagementTeam/ManagementTeamSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import PageSubNavigation from "@components/WebsiteRevamp/PageSubNavigation/PageSubNavigation"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import AdvisorsData from "@jsons/advisors.json"
import teamData from "@jsons/team.json"
import React from "react"

type Props = {}

const management = (props: Props): JSX.Element => {
	const AdvancedSideAsset = getTranslatedPageData(AdvisorsData, true, true)
	const list = getValueOrThrow(AdvancedSideAsset.AdvancedSideAsset)

	const team = getTranslatedPageData(teamData, true, true)
	const teamSections = getValueOrThrow(team.AdvancedSideAsset)

	return (
		<>
			<HeadMeta
				meta={AdvancedSideAsset.metaData}
				customPath="/about-us/advisors"
			/>
			<FullWidthHeader
				data={{
					title: teamSections[0].sectionTitle,
					subtitle: teamSections[0].sectionSubtitle,
				}}
				position={"left"}
				size={"L"}
			/>
			<Separator size={16} />
			{team.subMenu && <PageSubNavigation data={team.subMenu} />}
			{/* <Separator /> */}

			<ManagementTeamSection
				dataTop={list?.[0]}
				data={[...getValueOrThrow(list[0]?.mainContent)]}
			/>
		</>
	)
}

export default management
